import { render, staticRenderFns } from "./XImg.vue?vue&type=template&id=533ac755&scoped=true"
import script from "./XImg.vue?vue&type=script&lang=ts"
export * from "./XImg.vue?vue&type=script&lang=ts"
import style0 from "./XImg.vue?vue&type=style&index=0&id=533ac755&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ac755",
  null
  
)

export default component.exports